export default "__VITE_ASSET__BHKXomXP__"